module.exports = {
          srcSet: "/assets/images/abde381614340a200702ab155b16d1e1-400.png"+" 400w"+","+"/assets/images/d564513639dcd626121464df2e6fa77e-800.png"+" 800w"+","+"/assets/images/dffe6451b8fa77c558d4ca244a8a1586-1200.png"+" 1200w",
          images:[ {path: "/assets/images/abde381614340a200702ab155b16d1e1-400.png",width: 400,height: 138},{path: "/assets/images/d564513639dcd626121464df2e6fa77e-800.png",width: 800,height: 277},{path: "/assets/images/dffe6451b8fa77c558d4ca244a8a1586-1200.png",width: 1200,height: 415}],
          src: "/assets/images/abde381614340a200702ab155b16d1e1-400.png",
          toString:function(){return "/assets/images/abde381614340a200702ab155b16d1e1-400.png"},
          placeholder: undefined,
          width: 400,
          height: 138
      }